import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
  {
    id: 1,
    icon: 'Shield',
    title: 'HIPAA Compliant',
    description: 'Your data is protected under healthcare privacy standards'
  },
  {
    id: 2,
    icon: 'Lock',
    title: 'End-to-End Encrypted',
    description: 'All communications are fully encrypted'
  },
  {
    id: 3,
    icon: 'Award',
    title: 'Counselor Endorsed',
    description: 'Recommended by certified relationship therapists'
  }];

  // Testimonials removed - ready for live data integration
  const testimonials = [];

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-card border border-border rounded-lg p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-6">
          Your Privacy is Protected
        </h3>
        <div className="space-y-4 md:space-y-5">
          {certifications?.map((cert) =>
          <div key={cert?.id} className="flex items-start space-x-3 md:space-x-4">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-md flex items-center justify-center">
                <Icon name={cert?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base font-medium text-foreground mb-1">
                  {cert?.title}
                </h4>
                <p className="text-xs md:text-sm text-muted-foreground">
                  {cert?.description}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      {testimonials?.length > 0 && (
        <div className="bg-card border border-border rounded-lg p-4 md:p-6">
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-6">
            Trusted by Professionals
          </h3>
          <div className="space-y-4 md:space-y-6">
            {testimonials?.map((testimonial) =>
            <div key={testimonial?.id} className="space-y-3">
                <div className="flex items-center space-x-3">
                  <img
                  src={testimonial?.image}
                  alt={testimonial?.imageAlt}
                  className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover" />

                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm md:text-base font-medium text-foreground">
                      {testimonial?.name}
                    </h4>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      {testimonial?.role}
                    </p>
                  </div>
                </div>
                <p className="text-xs md:text-sm text-foreground italic pl-0 md:pl-[60px]">
                  "{testimonial?.quote}"
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 md:p-5">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-xs md:text-sm text-foreground">
              <strong>Important:</strong> Both partners must complete onboarding separately. Your individual responses remain private until you choose to share through the AI communication system.
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default TrustSignals;